export const SET_FILTER = 'SETTING/SET_FILTER'
export const SET_FILTERS = 'SETTING/SET_FILTERS'
